import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { LOGO_URL } from "@/lib/api";
import { Mail, ArrowLeft, Loader2 } from "lucide-react";

export default function AdminForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) return;
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
    } catch { /* generic by design */ }
    setSent(true);
    setBusy(false);
  };

  return (
    <div className="min-h-screen bg-[#070707] flex items-center justify-center p-6" data-testid="admin-forgot-page">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="Elite Pixels" className="h-16 mx-auto" />
          <div className="text-[0.55rem] tracking-[0.4em] uppercase text-white/40 mt-3">Admin · Password Recovery</div>
        </div>

        <div className="bg-[#0a0a0a] border border-white/10 p-8">
          {!sent ? (
            <>
              <h1 className="font-serif text-2xl mb-2">Forgot your password?</h1>
              <p className="text-sm text-white/60 mb-6 leading-relaxed">
                Enter the admin email and we'll send a one-time reset link. The link is valid for 60 minutes and
                can only be used once.
              </p>
              <form onSubmit={submit} className="space-y-4">
                <label className="block">
                  <span className="text-[0.6rem] tracking-[0.25em] uppercase text-white/60">Admin email</span>
                  <input type="email" required value={email} onChange={e => setEmail(e.target.value)}
                    autoComplete="email" autoFocus data-testid="forgot-email"
                    className="mt-1 w-full bg-black border border-white/15 px-3 py-2.5 text-sm focus:border-[#D4AF37] outline-none"
                    placeholder="admin@elitepixels.ca" />
                </label>
                <button type="submit" disabled={busy} className="btn-gold w-full justify-center"
                  data-testid="forgot-submit">
                  {busy ? <><Loader2 size={14} className="animate-spin"/> Sending…</> : <><Mail size={14}/> Send Reset Link</>}
                </button>
              </form>
            </>
          ) : (
            <div className="text-center" data-testid="forgot-sent">
              <div className="w-14 h-14 rounded-full bg-[#D4AF37]/10 border border-[#D4AF37]/40 flex items-center justify-center mx-auto mb-5">
                <Mail size={22} className="text-[#D4AF37]" />
              </div>
              <h2 className="font-serif text-2xl mb-3">Check your inbox</h2>
              <p className="text-sm text-white/65 leading-relaxed">
                If <strong className="text-white">{email}</strong> belongs to an admin account, a reset link is on
                its way. Look for an email from <span className="text-[#D4AF37]">Elite Pixels</span> in the next minute or two.
              </p>
              <p className="text-xs text-white/40 mt-4">Don't see it? Check spam, or request a new link in 60 seconds.</p>
            </div>
          )}

          <Link to="/admin/login" className="mt-6 flex items-center justify-center gap-2 text-xs tracking-widest uppercase text-white/40 hover:text-[#D4AF37] transition" data-testid="back-to-login">
            <ArrowLeft size={12}/> Back to sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
